<template>
  <page-header-wrapper>
    <!-- 仅 adminFlag 为真时展示数据看板 -->
    <div v-if="isAdmin" style="width: 100%;display: flex;">
      <div style="width: 100%;">
        <template>
          <div class="page-header-index-wide" style="padding:0 25px;">

            <a-row :gutter="16">
              <!-- 总用户量、会员用户总数、充值总金额统计卡片 -->
              <a-col :span="8" style="margin-bottom: 10px;">
                <a-card style="width: 100%;">
                  <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
                    <div style="flex: 1; text-align: center;">
                      <p style="margin-bottom: 2px; font-size: 15px; color: #666;">{{ $t('dashboard.totalUserCount') }}</p>
                      <p style="margin-bottom: 0;"><font size="5px">{{ totalUserCount }}</font></p>
                    </div>
                    <div style="flex: 1; text-align: center;">
                      <p style="margin-bottom: 2px; font-size: 15px; color: #666;">{{ $t('dashboard.totalVipCount') }}</p>
                      <p style="margin-bottom: 0;"><font size="5px">{{ totalVipCount }}</font></p>
                    </div>
                  </div>
                  <div style="text-align: center; margin-bottom: 0;">
                    <p style="margin-bottom: 2px; font-size: 15px; color: #666;">{{ $t('dashboard.totalRechargeAmount') }}</p>
                    <p style="margin-bottom: 0;"><font size="5px">{{ totalRechargeAmount }}{{'$'}}</font></p>
                  </div>
                  <div style="height: 32px;"></div>
                </a-card>
              </a-col>

              <a-col :span="8" style="margin-bottom: 10px;">
                <a-card style="width: 100%;">
                  <p v-if="userFlag=='a'">{{ $t('dashboard.today') + '   |   ' + $t('dashboard.newUserCount') }}</p>
                  <p v-if="userFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="userFlag=='b'">{{ $t('dashboard.yesterday') + '   |   ' + $t('dashboard.newUserCount') }}</p>
                  <p v-if="userFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="userFlag=='c'">{{ $t('dashboard.last7Days') + '   |   ' + $t('dashboard.newUserCount') }}</p>
                  <p v-if="userFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ userNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateUser(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      {{ $t('dashboard.today') }}
                    </a-radio-button>
                    <a-radio-button value="b">
                      {{ $t('dashboard.yesterday') }}
                    </a-radio-button>
                    <a-radio-button value="c">
                      {{ $t('dashboard.last7Days') }}
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :span="8" style="margin-bottom: 10px;">
                <a-card style="width: 100%;">
                  <p v-if="diominFlag=='a'">{{ $t('dashboard.today') + '   |   ' + $t('dashboard.rechargeCoinIncome') }}</p>
                  <p v-if="diominFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="diominFlag=='b'">{{ $t('dashboard.yesterday') + '   |   ' + $t('dashboard.rechargeCoinIncome') }}</p>
                  <p v-if="diominFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="diominFlag=='c'">{{ $t('dashboard.last7Days') + '   |   ' + $t('dashboard.rechargeCoinIncome') }}</p>
                  <p v-if="diominFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ totalNum }}{{'$'}}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateDiomn(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      {{ $t('dashboard.today') }}
                    </a-radio-button>
                    <a-radio-button value="b">
                      {{ $t('dashboard.yesterday') }}
                    </a-radio-button>
                    <a-radio-button value="c">
                      {{ $t('dashboard.last7Days') }}
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :span="12" style="margin-bottom: 10px;">
                <a-card style="width: 100%;">
                  <p v-if="vipFlag=='a'">{{ $t('dashboard.today') + '   |   ' + $t('dashboard.vipIncome') }}</p>
                  <p v-if="vipFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="vipFlag=='b'">{{ $t('dashboard.yesterday') + '   |   ' + $t('dashboard.vipIncome') }}</p>
                  <p v-if="vipFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="vipFlag=='c'">{{ $t('dashboard.last7Days') + '   |   ' + $t('dashboard.vipIncome') }}</p>
                  <p v-if="vipFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ manNum }}{{'$'}}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateVip(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      {{ $t('dashboard.today') }}
                    </a-radio-button>
                    <a-radio-button value="b">
                      {{ $t('dashboard.yesterday') }}
                    </a-radio-button>
                    <a-radio-button value="c">
                      {{ $t('dashboard.last7Days') }}
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>


              <a-col :span="12" style="margin-bottom: 10px;">
                <a-card style="width: 100%;" >
                  <p v-if="buyFlag=='a'">{{ $t('dashboard.today') + '   |   ' + $t('dashboard.episodeIncome') }}</p>
                  <p v-if="buyFlag=='a'">{{ this.data(1) }}</p>
                  <p v-if="buyFlag=='b'">{{ $t('dashboard.yesterday') + '   |   ' + $t('dashboard.episodeIncome') }}</p>
                  <p v-if="buyFlag=='b'">{{ this.data(2) }}</p>
                  <p v-if="buyFlag=='c'">{{ $t('dashboard.last7Days') + '   |   ' + $t('dashboard.episodeIncome') }}</p>
                  <p v-if="buyFlag=='c'">{{ this.data(3) }}</p>
                  <p><font size="6px">{{ $t('dashboard.coinCount') + '：' + dionNum }}</font></p>
                  <a-radio-group default-value="a" @change="(e) => updateBuy(e.target.value)" button-style="solid">
                    <a-radio-button value="a">
                      {{ $t('dashboard.today') }}
                    </a-radio-button>
                    <a-radio-button value="b">
                      {{ $t('dashboard.yesterday') }}
                    </a-radio-button>
                    <a-radio-button value="c">
                      {{ $t('dashboard.last7Days') }}
                    </a-radio-button>
                  </a-radio-group>
                </a-card>
              </a-col>
              <a-col :span="12" style="margin-bottom: 10px; display: flex; justify-content: center;">
                <div id="myChart" :style="{width: '100%', height: '250px'}" style="background-color: white;"></div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 10px; display: flex; justify-content: center;">
                <div id="myChart4" :style="{width: '100%', height: '250px'}" style="background-color: white;"></div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 10px; display: flex; justify-content: center;">
                <div id="myChart1" style="width: 100%;margin-top: 1%;background-color: white;" :style="{height: '400px'}"></div>
              </a-col>
              <a-col :span="12" style="margin-bottom: 10px; display: flex; justify-content: center;">
                <div id="myChart3" style="width: 100%;margin-top: 1%;background-color: white;" :style="{height: '400px'}"></div>
              </a-col>
            </a-row>

          </div>
        </template>
      </div>
    </div>
    <!-- 非管理员视图（分销商视图）— 暂时关闭，仅保留管理员数据看板
    <div v-else style="width: 100%;"> ... </div>
    -->

  </page-header-wrapper>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import * as echarts from 'echarts'
import {
  getInstutionByDay,
  getBuyVipData,
  getUserData,
  getRechargePal,
  // getDisRechargePal,
  getALLCollectNum,
  getDiomnData,
  // updateDisDiomn,
  // updateOrderDiomn,
  // updateRechargeDiomn,
  getVipData,
  // getDisUserData,
  getRuioDataByDay,
  // getDisInstutionByDay,
  // getMoneyInstutionByDay,
  // getMoneyRechargePal,
  getBuyData
} from '@/api/system/user'
import { getUserVipDatas } from '@/api/system/data'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data() {
    return {
      // 图表数据
      xInstutiondata: [], // 用户充值概览X轴数据（日期）
      yInstutiondata1: [], // 用户充值概览Y轴数据（订单数）
      xInstutiondata1s: [], // 用户充值概览X轴数据（备用）
      yInstutiondata1s: [], // 用户充值概览Y轴数据（收入）
      xInstutiondata4: [], // 会员订阅概览X轴数据（日期）
      yInstutiondata4: [], // 会员订阅概览Y轴数据（订阅数）
      yInstutiondata4s: [], // 会员订阅概览Y轴数据（收入）
      dataList: [], // 饼图1数据
      rechargeData: [], // 饼图2数据（充值数据）
      disRechargeData: [], // 饼图3数据（分销商充值数据）
      moneyRechargeData: [], // 饼图4数据（佣金收入数据）
      xDisInstutiondata: [], // 下级用户充值概览X轴数据（日期）
      yDisInstutiondata: [], // 下级用户充值概览Y轴数据
      xMoneyInstutiondata: [], // 佣金收入概览X轴数据（日期）
      yMoneyInstutiondata: [], // 佣金收入概览Y轴数据


      // 图表数据标志位
      userFlag: 'a', // 新增用户数时间筛选标志
      DisUserFlag: 'a', // 分销商新增用户数时间筛选标志
      diominFlag: 'a', // 充值金币收入时间筛选标志
      orderFlag: 'a', // 订单数时间筛选标志
      rechargeFlag: 'a', // 充值金额时间筛选标志
      disDiominFlag: 'a', // 分销商佣金收入时间筛选标志
      vipFlag: 'a', // 会员收入时间筛选标志
      buyFlag: 'a', // 购买剧集收入时间筛选标志
      rechargeData: [],
      disRechargeData: [],
      moneyRechargeData: [],

      xdevicedata: [],
      ydevicedata1: [],
      ydevicedata2: [],

      userDayOneData: [],
      userDayTwoData: [],

      xDisInstutiondata: [], // 下级用户充值概览X轴数据（日期）
      yDisInstutiondata: [], // 下级用户充值概览Y轴数据
      xMoneyInstutiondata: [], // 佣金收入概览X轴数据（日期）
      yMoneyInstutiondata: [], // 佣金收入概览Y轴数据
      // 统计数据
      userNum: "0", // 新增用户数
      disUserNum: "0", // 分销商新增下级用户数
      totalNum: "0", // 累计充值金币收入
      disTotalNum: "0", // 分销商累计佣金收入
      orderNum: "0", // 下级用户充值订单数
      rechargeNum: "0", // 下级用户充值金额
      manNum: "0", // 累计购买会员收入
      dionNum: "0", // 累计购买剧集收入（金币数）
      // 总统计数据
      totalUserCount: "0", // 总用户数
      totalVipCount: "0", // 会员用户总数
      totalRechargeAmount: "0", // 充值总金额
      timeFix: timeFix() // 时间问候语
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname',
      'userInfo'
    ]),
    isAdmin () {
      const flag = this.userInfo && this.userInfo.adminFlag
      return flag === true || flag === 1 || flag === '1'
    }
  },
  created() {
    if (!this.isAdmin) {
      return
    }
    this.updateUser('a')
    this.updateDiomn('a')
    this.updateVip('a')
    this.updateBuy('a')
    this.getTotalStatistics()
  },
  mounted() {
    if (!this.isAdmin) {
      return
    }
    this.$nextTick(() => {
      this.drawLine1()
      this.drawLine2()
      this.drawLine3()
      this.drawLine4()
    })
  },
  methods: {
    /**
     * 更新新增用户数统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateUser(value) {
      this.userFlag = value
      getUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.userNum = data + "";
      });
    },
    /**
     * 更新分销商新增下级用户数统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateDisUser(value) {
      this.DisUserFlag = value
      getDisUserData({
        type: value
      }).then(res => {
        const data = res.data;
        this.disUserNum = data + "";
      });
    },
    /**
     * 更新累计充值金币收入统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateDiomn(value) {
      this.diominFlag = value
      getDiomnData({
        type: value
      }).then(res => {
        const data = res.data;
        this.totalNum = data + "";
      });
    },


    /**
     * 更新分销商累计佣金收入统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateDisDiomn(value) {
      this.disDiominFlag = value
      updateDisDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.disTotalNum = data + "";
      });
    },


    /**
     * 更新下级用户充值订单数统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateOrderDiomn(value) {
      this.orderFlag = value
      updateOrderDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.orderNum = data + "";
      });
    },

    /**
     * 更新下级用户充值金额统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateRechargeDiomn(value) {
      this.rechargeFlag = value
      updateRechargeDiomn({
        type: value
      }).then(res => {
        const data = res.data;
        this.rechargeNum = data + "";
      });
    },

    /**
     * 更新累计购买会员收入统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateVip(value) {
      this.vipFlag = value
      getVipData({
        type: value
      }).then(res => {
        const data = res.data;
        this.manNum = data + "";
      });
    },
    /**
     * 更新累计购买剧集收入统计
     * @param {string} value - 时间类型：'a'今日, 'b'昨日, 'c'近七日
     */
    updateBuy(value) {
      this.buyFlag = value
      getBuyData({
        type: value
      }).then(res => {
        const data = res.data;

        data.forEach((el) => {
          if (el.type == '1') {
            this.womanNum = el.price + "";
          }
          if (el.type == '2') {
            this.dionNum = el.price + "";
          }
        });
      });
    },
    /** 获取总统计数据（总用户量、会员用户总数、充值总金额） */
    getTotalStatistics() {
      // 获取用户统计数据
      getUserVipDatas().then(response => {
        if (response.data) {
          const data = response.data
          // 总用户量
          this.totalUserCount = (data.totalUserCount || 0) + ""
          // 会员用户总数
          this.totalVipCount = (data.totalVipCount || 0) + ""
          this.totalRechargeAmount = (data.totalRechargeAmount || 0) + ""
        }
      }).catch(error => {
        console.error('获取用户统计数据失败:', error)
      })
    },
    /**
     * 获取日期范围字符串
     * @param {number} value - 1:今日, 2:昨日, 3:近七日
     * @returns {string} 日期范围字符串，格式：YYYY-MM-DD~YYYY-MM-DD
     */
    data(value) {
      if (value === 1) {
        // 今日
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1
        const day = today.getDate()
        return `${year}-${month}-${day}~${year}-${month}-${day}`
      }
      if (value === 2) {
        // 昨日
        const today = new Date()
        const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        const year = yesterday.getFullYear()
        const month = yesterday.getMonth() + 1
        const day = yesterday.getDate()
        return `${year}-${month}-${day}~${year}-${month}-${day}`
      }
      if (value === 3) {
        // 近七日
        const today = new Date()
        const yesterday = new Date(today.getTime() - 144 * 60 * 60 * 1000)
        const startYear = yesterday.getFullYear()
        const startMonth = yesterday.getMonth() + 1
        const startDay = yesterday.getDate()
        const endYear = today.getFullYear()
        const endMonth = today.getMonth() + 1
        const endDay = today.getDate()
        return `${startYear}-${startMonth}-${startDay}~${endYear}-${endMonth}-${endDay}`
      }
    },

    /**
     * 绘制用户充值概览图表（折线图）
     * 显示充值订单数和充值收入趋势
     */
    drawLine1() {
      getInstutionByDay().then(res => {
        this.xInstutiondata = [];
        this.yInstutiondata1 = [];
        this.xInstutiondata1s = [];
        this.yInstutiondata1s = [];
        if (res.data) {
          // 处理订单数数据
          const data = res.data.orderNum
          data.forEach((el) => {
            this.xInstutiondata.push(el.times)
            this.yInstutiondata1.push(Number(el.nums))
          })
          // 处理收入数据
          res.data.orderMoney.forEach((el) => {
            this.yInstutiondata1s.push(Number(el.moneys))
          })
          // 初始化图表
          const myChart = echarts.init(document.getElementById('myChart'))
          const option = {
            title: {
              text: this.$t('dashboard.userRechargeOverview'),
              left: '5%',
              top: '2%',
              textStyle: {
                fontSize: 16,
                fontWeight: 'bold'
              },
              padding: [10, 0, 10, 15]
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: [this.$t('dashboard.rechargeIncome'), this.$t('dashboard.rechargeOrderNum')],
              top: '8%',
              left: 'center'
            },
            grid: {
              left: '8%',
              right: '8%',
              top: '25%',
              bottom: '15%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: this.$t('dashboard.rechargeOrderNum'),
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata1
              },
              {
                name: this.$t('dashboard.rechargeIncome'),
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata1s
              }
            ]
          }
          myChart.setOption(option)
        }
      });

    },


    /**
     * 绘制下级用户充值概览图表（折线图）
     * 显示分销商下级用户充值金额趋势
     */
    drawLine5() {
      getDisInstutionByDay().then(res => {
        this.xDisInstutiondata = []
        this.yDisInstutiondata = []
        if (res.data) {
          const data = res.data
          data.forEach((el) => {
            this.xDisInstutiondata.push(el.times)
            this.yDisInstutiondata.push(Number(el.nums))
          })
          // 初始化图表
          const myChart = echarts.init(document.getElementById('myChart5'))
          var option = {
            title: {
              text: this.$t('dashboard.subUserRechargeOverview'),
              left: '5%',
              top: '2%',
              textStyle: {
                fontSize: 16,
                fontWeight: 'bold'
              },
              padding: [10, 0, 10, 15]
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: [this.$t('dashboard.rechargeAmount')],
              top: '8%',
              left: 'center'
            },
            grid: {
              left: '8%',
              right: '8%',
              top: '25%',
              bottom: '15%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xDisInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: this.$t('dashboard.rechargeOrderNum'),
                type: 'line',
                stack: 'Total',
                data: this.yDisInstutiondata
              }
            ]
          }
          myChart.setOption(option)
        }
      });

    },


    /**
     * 绘制佣金收入概览图表（折线图）
     * 显示分销商佣金收入趋势
     */
    drawLine6() {
      getMoneyInstutionByDay().then(res => {
        this.xMoneyInstutiondata = []
        this.yMoneyInstutiondata = []
        if (res.data) {
          const data = res.data
          data.forEach((el) => {
            this.xMoneyInstutiondata.push(el.times)
            this.yMoneyInstutiondata.push(Number(el.nums))
          })
          // 初始化图表
          const myChart = echarts.init(document.getElementById('myChart6'))
          var option = {
            title: {
              text: this.$t('dashboard.commissionIncomeOverview'),
              left: '5%',
              top: '2%',
              textStyle: {
                fontSize: 16,
                fontWeight: 'bold'
              },
              padding: [10, 0, 10, 15]
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: [this.$t('dashboard.commissionIncomeOverview')],
              top: '8%',
              left: 'center'
            },
            grid: {
              left: '8%',
              right: '8%',
              top: '25%',
              bottom: '15%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xMoneyInstutiondata
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: this.$t('dashboard.commissionIncome'),
                type: 'line',
                stack: 'Total',
                data: this.yMoneyInstutiondata
              }
            ]
          }
          myChart.setOption(option)
        }
      });

    },

    /**
     * 绘制饼图1（环形图）
     * 显示数据分布情况
     */
    drawLine2() {
      getRuioDataByDay().then(res => {
        this.dataList = []
        if (res.data) {
          console.log(res.data);
          // 国际化处理 dataList 中的 name 字段
          const nameMap = {
            '累计金币收入': this.$t('dashboard.totalCoinIncome'),
            '累计会员充值收入': this.$t('dashboard.totalVipRechargeIncome'),
            '累计剧集购买收入': this.$t('dashboard.totalEpisodePurchaseIncome')
          }
          this.dataList = res.data.map(item => ({
            ...item,
            name: nameMap[item.name] || item.name
          }))
          const chartDom = document.getElementById('myChart1')
          const myChart = echarts.init(chartDom)
          const option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: this.$t('dashboard.dataValue'),
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'


                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: true
                },
                data: this.dataList
              }
            ]
          }
          myChart.setOption(option)
        }
      });
    },
    /**
     * 绘制饼图2（环形图）
     * 显示充值数据分布情况
     */
    drawLine3() {
      getRechargePal().then(res => {
        this.rechargeData = []
        if (res.data) {
          console.log('this.rechargeData')
          // 国际化处理 rechargeData 中的 name 字段
          const nameMap = {
            'paypay': this.$t('dashboard.paypay'),
            'IOS内购': this.$t('dashboard.iosPurchase')
          }
          this.rechargeData = res.data.map(item => ({
            ...item,
            name: nameMap[item.name] || item.name
          }))
          console.log(this.rechargeData)

          const chartDom = document.getElementById('myChart3')
          const myChart = echarts.init(chartDom)
          const option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: this.$t('dashboard.rechargeCount'),
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: true,
                  position: 'inner',
                  formatter: '{c}'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.rechargeData
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },


    /**
     * 绘制饼图3（环形图）
     * 显示分销商充值人数分布情况
     */
    drawLine7() {
      getDisRechargePal().then(res => {
        this.disRechargeData = []
        if (res.data) {
          this.disRechargeData = res.data
          const chartDom = document.getElementById('myChart7')
          const myChart = echarts.init(chartDom)
          const option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: this.$t('dashboard.peopleCount'),
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.disRechargeData
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },


    /**
     * 绘制饼图4（环形图）
     * 显示佣金收入人数分布情况
     */
    drawLine8() {
      getMoneyRechargePal().then(res => {
        this.moneyRechargeData = []
        if (res.data) {
          this.moneyRechargeData = res.data
          const chartDom = document.getElementById('myChart8')
          const myChart = echarts.init(chartDom)
          const option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: this.$t('dashboard.peopleCount'),
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                padAngle: 5,
                itemStyle: {
                  borderRadius: 10
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.moneyRechargeData
              }
            ]
          };

          option && myChart.setOption(option);
        }
      });
    },




    /**
     * 绘制会员订阅概览图表（折线图）
     * 显示订阅数和订阅收入趋势
     */
    drawLine4() {
      getBuyVipData().then(res => {
        this.xInstutiondata4 = []
        this.yInstutiondata4 = []
        this.yInstutiondata4s = []
        if (res.data) {
          // 处理订阅数数据
          const data = res.data.orderNum
          data.forEach((el) => {
            this.xInstutiondata4.push(el.times)
            this.yInstutiondata4.push(Number(el.nums))
          })
          // 处理订阅收入数据
          res.data.orderMoney.forEach((el) => {
            this.yInstutiondata4s.push(Number(el.moneys))
          })
          // 初始化图表
          const myChart4 = echarts.init(document.getElementById('myChart4'))
          const option = {
            title: {
              text: this.$t('dashboard.vipSubscriptionOverview'),
              left: '5%',
              top: '2%',
              textStyle: {
                fontSize: 16,
                fontWeight: 'bold'
              },
              padding: [10, 0, 10, 15]
            },
            tooltip: {
              trigger: 'item',
              triggerOn: "mousemove",
            },
            legend: {
              data: [this.$t('dashboard.subscriptionIncome'), this.$t('dashboard.subscriptionCount')],
              top: '8%',
              left: 'center'
            },
            grid: {
              left: '8%',
              right: '8%',
              top: '25%',
              bottom: '15%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.xInstutiondata4
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: this.$t('dashboard.subscriptionCount'),
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata4
              },
              {
                name: this.$t('dashboard.subscriptionIncome'),
                type: 'line',
                stack: 'Total',
                data: this.yInstutiondata4s
              }
            ]
          }
          myChart4.setOption(option)
        }
      });
    }

  },
}
</script>

<style lang="less" scoped>
@import "./index.less";

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

</style>
